import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;



export async function getMatchedBets(eventtypeid) {
  try {
    const response = await serviceContext.post(ReportsURL + "bets/user/open/eventtype", JSON.stringify(eventtypeid), options);
    if (response.hasError === true) {
        return false;
    }
    else {
        const res = response.json();
        return res;
    }
    
  }
  catch (error) {
    return error;
  }
}

export async function placeOrder(data) {
  try {
      const response = await serviceContext.post("binary/orders", JSON.stringify(data), options);
      if(response.hasError === true){
          return false;
      }
      else{
          const res = response.json();
          return res;
      }
  }
  catch (error) {
      return error;
  }
};
